import { Vue, Component, Watch } from 'vue-property-decorator'
import carritos from '@/store/modules/CarritoModule'
import articulos from '@/store/modules/ArticuloModule'
import auth from '@/store/modules/AuthModule'

@Component
export default class AppBar extends Vue {
  nombre = ''
  loading = false

  get isAuth () {
    return auth.isAuth
  }

  @Watch('nombre')
  onChangeNombre (value: string) {
    if (!value) {
      return
    }
    if (value.length <= 3) {
      return
    }

    if (this.loading) {
      return
    }

    this.loading = true
    articulos.fetchSearchAll(value).finally(() => (this.loading = false))
  }

  get countItems () {
    return carritos.countItems
  }

  get articulos () {
    return articulos.itemsSearch
  }

  onSelectArticulo (id: string) {
    this.$router.push(`/articulo/agregar/${id}`)
  }

  cerrarSesion () {
    auth.removeToken()
    window.sessionStorage.removeItem('token')
  }
}
